module.exports = __webpack_public_path__ + "img/recommed-img2.4ff669ef.jpg";